/**
 * 拼单确认弹层
 */
import React, { FC, ReactNode } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { classNames } from '@dt/fe-utils'
import { IonModal, IonContent, IonHeader, IonFooter } from '@ionic/react'
import { modalLayer } from '@utils'
import './index.scss'
import { Icon, Advert as MenuAdvert } from '@cps'
import { advertMobx } from '@mobxStore'

// interface
export interface IProps {
  className?: string;
  title?: string;
  desc?: string;
  canClose?: boolean;
  confirmText?: ReactNode;
  cancelText?: ReactNode;
  reject?: any;
  resolve?: any;
  backdropDismiss?: boolean;
  hasFooter?: boolean;
}

const defaultImg = 'http://eshine-image.oss-cn-hangzhou.aliyuncs.com/product/7178bc33e9c44bdaba2f1e21db128acb.png'

const ConfirmModal: FC<IProps> = (props) => {
  const { className, title = '', confirmText = i18n.t('common.ok'), desc = '', cancelText, canClose = true, reject, resolve, backdropDismiss = true, } = props
  const { availableAdsMap } = advertMobx
  const key = 'buyTogether'
  const handleConfirm = function () {
    resolve && resolve(true)
    modalLayer.resolve(true)
  }
  return (
    <IonModal
      isOpen
      backdropDismiss={backdropDismiss}
      cssClass={classNames('btcart-confirm-modal', className)}
    >
      <IonHeader>
        <div className='btcart-advert-wrapper'>
          <img className='advert-img' src={availableAdsMap[key]?.[0]?.pic || defaultImg} alt='' />
        </div>
        {
          !!canClose && (
            <i
              className='iconfont icon-close' data-cypid='btcartConfirmModalClose' onClick={() => {
                reject && reject(false)
                modalLayer.reject(false)
              }}
            >
            </i>
          )
        }
      </IonHeader>
      <IonContent>
        <div className='ion-content-wrap'>
          <div className='info-wrapper'>
            <div className='info-contenr-wrap'>
              <div className='title'>{title}</div>
              {!!desc && <div className='desc'>{desc}</div>}
            </div>
          </div>
        </div>
      </IonContent>
      <IonFooter>
        <div className='footer-btn'>
          {!!cancelText && (
            <div
              className='confirm'
              data-cypid='btcartConfirmModalCancel'
              onClick={() => modalLayer.reject(true)}
            >{cancelText}
            </div>
          )}
          <div
            data-cypid='btcartConfirmModalConfirm'
            onClick={handleConfirm}
            className='confirm'
          >{confirmText}
          </div>
        </div>
      </IonFooter>
    </IonModal>
  )
}

export default observer(ConfirmModal)
